export const MOBILE_APP_IMAGES = {
  iosImage: 'https://images.grove.co/upload/global/app-store.svg',
  androidImage:
    'https://images.grove.co/upload/global/google-play-badge-vector.svg',
}
